import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    root: {
      // marginBottom: theme.spacing(2),
      boxShadow: 'none',
      border: '1px solid #cfd8dc',
      borderRadius: 4,
      background: '#f7f8f8',
      minHeight: '95px !important',
      padding: theme.spacing(0),
      paddingBottom: theme.spacing(0.5),
      boxSizing: 'border-box',
      margin: 0,
      '& .MuiAccordionSummary-content': {
        margin: 0,
        padding: 0,
      },
    },

    content: {
      paddingBottom: theme.spacing(0.5),
    },
    // Key Header
    titlePart: {
      marginInlineEnd: 'auto',
    },
    titleText: {
      fontSize: 16,

      fontWeight: 'normal',
    },
    subtitleText: {
      fontSize: 12,
      color: '#546e7a',
      fontWeight: 'normal',
      marginTop: theme.spacing(0.5),
    },
    actionButtons: {
      marginTop: theme.spacing(0),
      marginInlineStart: theme.spacing(-0.5),
    },
    actionButton: {
      color: theme.palette.primary.main,
      paddingInlineStart: theme.spacing(2),
      paddingInlineEnd: theme.spacing(2),
    },
    balanceTitle: {
      marginTop: theme.spacing(2),
      fontSize: 12,

      fontWeight: 'bold',
    },
    balanceMoney: {
      fontSize: 16,

      fontWeight: 'normal',
      '& span': {
        fontSize: 14,

        marginInlineStart: theme.spacing(0.5),
      },
    },
    titleActions: {
      marginInlineEnd: theme.spacing(-1.5),
      marginTop: theme.spacing(-0.5),
    },
    actionsIcon: {
      marginInlineStart: theme.spacing(0.5),
      color: '#7d8f9b',
      padding: theme.spacing(1),
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    propertyContainer: {
      marginTop: theme.spacing(3),
    },
    property: {
      fontSize: 14,

      fontWeight: '400',
    },
    propertyIcon: {
      fontSize: 25,

      marginInlineEnd: theme.spacing(1),
    },
    otherActions: {
      padding: '0',
      margin: '0',
      alignItems: 'center',
      justifyContent: 'center',
    },
    otherActionsMenu: {
      border: '1px solid #d8d1d1',
      '& .MuiButtonBase-root.Mui-disabled': {
        pointerEvents: 'auto !important',
      },
    },
    otherActionsMenuItem: {
      fontSize: '12px',
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    otherActionsMenuItemIcon: {
      marginRight: '5px',
    },
    sheba: {
      marginTop: theme.spacing(1),
    },
    shebaNumber: {
      fontSize: 14,
      color: '#546e7a',
      fontWeight: 'normal',
      fontFamily: 'Vazir',
      overflowWrap: 'break-word',
    },
    copyIcon: {
      fontSize: 15,
    },
    copyIconButton: {
      width: 15,
      height: 15,
      marginInlineStart: theme.spacing(1),
      marginTop: -2,
    },
  };
});

export const useStylesOperationDialog = makeStyles((theme) => ({
  dialogMain: {
    '& .MuiDialog-paper': {
      borderRadius: '10px',
      overflowY: 'inherit',
    },
    '& .MuiDialogContent-root': {
      overflowY: 'auto',
      '&::scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-moz-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-thumb': {
        width: '0',
        minWidth: '0',
      },
      '&.noneOverFlow': {
        overflowY: 'inherit',
      },
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'flex-start',
      display: 'flex',
      flexDirection: 'row-reverse',
      padding: '20px',
      gap: '15px',
    },
    '& .MuiDialog-container': {
      width: '100vw',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  },
  title: {
    margin: 0,
    padding: '20px',
    borderBottom: '1px solid #E2E5E9',

    '& h2': {
      fontSize: 16,
      color: '#0C0E10',
    },
  },
  dialog: {
    textAlign: 'left',
    direction: 'ltr',
    padding: theme.spacing(2),
    // MUI removes the top padding when DialogContent follows DialogTitle.
    paddingTop: `${theme.spacing(2)} !important`,
    lineHeight: 2,
    overflowY: 'hidden',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

export const useStylesColumns = makeStyles((theme) => ({
  profileImage: {
    width: 30,
    height: 30,
    borderRadius: 15,
    marginBottom: -19,
  },
  btnActions: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column-reverse',
    },
  },
  targetUser: {
    padding: 0,
    backgroundColor: theme.palette.gray[0],
    boxShadow: 'none',
    border: `1px solid ${theme.palette.gray[1]}`,
    borderRadius: 32,
    backgroundColor: '#e0e0e0',
  },
  targetContainer: {
    padding: theme.spacing(0.5, 1),
  },
  targetFullName: {
    fontSize: 14,
  },
  targetUsername: {
    fontSize: 12,
    fontWeight: 'bold',
    fontFamily: 'Vazir',
  },
  targetId: {
    fontSize: 12,
  },
  contentUser: {
    padding: '0 8px',
  },
  toolbar: {
    marginTop: 4,
    marginBottom: 8,
  },
  boxFile: {
    marginBottom: '8px',
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
  },
  trashIconButton: {
    height: 30,
    width: 30,
    marginInlineStart: theme.spacing(1),
    marginTop: -2,
  },
  trashIcon: {
    fontSize: 14,
  },
  dot: {
    width: 5,
    height: 5,
    borderRadius: 5,
    display: 'inline-block',
    background: theme.palette.gray[2],
    marginInlineStart: theme.spacing(1),
    marginInlineEnd: theme.spacing(1),
  },
}));
